export default {
  multiPropertyEmail: 'Bmail::MultiPropertyEmail',
  propertyEmail: 'Bmail::PropertyEmail',
  spaceNeedsEmail: 'Bmail::SpaceNeedsEmail'
};
